import { ISendPasswordRecoveryDTO } from 'modules/authentication/domain/dtos';
import { IPasswordRecoveriesRepository } from 'modules/authentication/domain/repositories';

export class SendPasswordRecoveryUseCase {
  constructor(
    private passwordRecoveriesRepository: IPasswordRecoveriesRepository,
  ) {}

  public async execute({
    document,
    sendEmail,
    sendSms,
    sendWhatsapp,
  }: ISendPasswordRecoveryDTO) {
    return this.passwordRecoveriesRepository.create({
      document,
      sendEmail,
      sendSms,
      sendWhatsapp,
    });
  }
}
